/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section5_P1Inputs */

const en_about_section5_p1 = /** @type {(inputs: About_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is open source and welcomes contributions. Visit our GitHub repository to report bugs, suggest features, or contribute code. Together, we can make JSON tools better for everyone.`)
};

const ko_about_section5_p1 = /** @type {(inputs: About_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 오픈 소스이며 기여를 환영합니다. GitHub 저장소를 방문하여 버그를 보고하거나, 기능을 제안하거나, 코드에 기여해 주세요. 함께 더 나은 JSON 도구를 만들어 갑시다.`)
};

const ja_about_section5_p1 = /** @type {(inputs: About_Section5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはオープンソースであり、貢献を歓迎します。GitHubリポジトリを訪問して、バグの報告、機能の提案、コードの貢献をしてください。一緒により良いJSONツールを作りましょう。`)
};

/**
* | output |
* | --- |
* | "PureJSON is open source and welcomes contributions. Visit our GitHub repository to report bugs, suggest features, or contribute code. Together, we can make J..." |
*
* @param {About_Section5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section5_p1 = /** @type {((inputs?: About_Section5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section5_p1(inputs)
	if (locale === "ko") return ko_about_section5_p1(inputs)
	return ja_about_section5_p1(inputs)
});